import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-vdd-enum-readonly',
  templateUrl: './vdd-enum-readonly.component.html',
  styleUrls: ['./vdd-enum-readonly.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddEnumReadonlyComponent {
  @Input() value: string;
  @Input() label: string;
  constructor() {}
}
